<template>
  <div v-if="$store.state.app.appNavBar">
    <date-range-picker
      ref="picker"
      :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd' }"
      :singleDatePicker="period !== 'range'"
      :date-format="dateFormat"
      show-dropdowns
      v-model="date"
      @select="select"
    >
      <template v-slot:input="picker" style="min-width: 350px;">
        {{ date.startDate | date }} - {{ date.endDate | date }}
      </template>
      <template #ranges="ranges">
        <div class="ranges">
          <ul>
            <li v-for="o in options" :key="o.value" @click="selectPeriod(o.value)">
              <b :class="{isActive: o.value === period}">{{ o.text }}</b>
            </li>
          </ul>
        </div>
      </template>
      <div slot="footer" slot-scope="data" class="slot">
        <div>
          <b class="black">{{ data.rangeText }}</b>
        </div>
        <div style="margin-left: auto">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary" @click="apply">
            Apply
          </b-button>
        </div>
      </div>
    </date-range-picker>
  </div>
</template>

<script>
import { BButton, BPopover, BForm, BCalendar, BFormGroup, BFormRadioGroup } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vSelect from 'vue-select'
import moment from 'moment'
import { getDateFromPeriod } from '@core/utils/helpers'
import store from '@/store'
import emitter from '@core/utils/emitter'
import hmStorage from '@core/utils/hm_storage'

export default {
  components: {
    BButton,
    BPopover,
    BForm,
    BCalendar,
    BFormGroup,
    BFormRadioGroup,
    vSelect,
    DateRangePicker
  },
  directives: {
    Ripple
  },
  data() {
    return {
      date: store.state.app.range,
      period: store.state.app.period,
      options: [
        { text: 'Day', value: 'day' },
        { text: 'Week', value: 'week' },
        { text: 'Month', value: 'month' },
        { text: 'Year', value: 'year' },
        { text: 'Range', value: 'range' }
      ],
      period_date: getDateFromPeriod('month', new Date()),
      selected_date: {startDate: new Date(), endDate: new Date()}
    }
  },
  filters: {
    date (val) {
      return val ? moment(val).format('YYYY-MM-DD') : ''
    }
  },
  methods: {
    selectPeriod(p) {
      this.period = p
      this.period_date = getDateFromPeriod(this.period, this.selected_date.startDate, this.selected_date.endDate)
    },
    dateFormat (classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() > new Date()
      }
      return classes
    },
    select(dateRange) {
      this.period_date = getDateFromPeriod(this.period, dateRange.startDate, dateRange.endDate)
      this.selected_date = dateRange
    },
    apply() {
      this.date.startDate = this.period_date[0]
      this.date.endDate = this.period_date[1]
      hmStorage.setLocalItem('period', this.period)
      hmStorage.setLocalItem('range', this.date)
      store.commit('app/SET_APP_STATE', {period: this.period, range: this.date})
      this.$refs.picker.togglePicker()
      emitter.emit('change_calendar')
    }
  },
  mounted() {
    this.date = store.state.app.range
    this.select(store.state.app.range)
    this.selectPeriod(store.state.app.period)
  }
}
</script>
<style>
.slot {
   background-color: #F5F5F5;
   padding: 0.5rem;
   color: white;
   display: flex;
   align-items: center;
   justify-content: space-between;
 }
.vue-daterange-picker {
  vertical-align: middle;
}
.reportrange-text {
  display: flex !important;
  align-items: center;
}
.isActive {
  color: #9188F3;
}
</style>
